import { app } from '../../../../../app';

app.component('usersSideMenu', {
    bindings: {
    },
    templateUrl: require('./users-side-menu.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/users-side-menu/users-side-menu.component.js